import { useMutation, useQueryClient } from '@tanstack/react-query';
import { surveysQueryKeys } from '../Constants/queryKeys';
import { saveSurveyQuestions } from '../Services/Surveys.service';
import type { SaveQuestionsPayload } from '../Types/Surveys.types';

/**
 * Saves the whole questionnaire.
 *
 * No toast on failure: the `409` this can raise is not an error to report, it is the version
 * dialog opening. The caller decides what each failure means.
 */
export const useSaveSurveyQuestions = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, payload }: { id: string; payload: SaveQuestionsPayload }) =>
      saveSurveyQuestions(id, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: surveysQueryKeys.details() });
      queryClient.invalidateQueries({ queryKey: surveysQueryKeys.lists() });
    },
  });
};
